var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authorinfo"},[_c('div',{staticClass:"authorsummary"},[_c('div',{staticClass:"top_Bar"},[_vm._v("作者")]),_vm._v(" "),_c('router-link',{attrs:{"to":{
            name: 'user_info',
            params: {
              name: _vm.userinfo.loginname
            }
          }}},[_c('img',{staticClass:"side_user_avatar",attrs:{"src":_vm.userinfo.avatar_url,"alt":"replay_avatar"}})])],1),_vm._v(" "),_c('div',{staticClass:"recent_topics"},[_c('div',{staticClass:"top_Bar"},[_vm._v("作者最近主题")]),_vm._v(" "),_c('ul',{staticClass:"inner_content"},_vm._l((_vm.topiclimitby5),function(list){return _c('li',[_c('router-link',{attrs:{"to":{
          name: 'post_content',
          params: {
            id: list.id,
            name: list.author.loginname
          }
        }}},[_vm._v("\n          "+_vm._s(list.title)+"\n        ")])],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"recent_replies"},[_c('div',{staticClass:"top_Bar"},[_vm._v("作者最近回复")]),_vm._v(" "),_c('ul',{staticClass:"inner_content"},_vm._l((_vm.replylimitby5),function(list){return _c('li',[_c('router-link',{attrs:{"to":{
          name: 'post_content',
          params: {
            id: list.id,
            name: list.author.loginname
          }
        }}},[_vm._v("\n          "+_vm._s(list.title)+"\n        ")])],1)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bf98494","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slideBar.vue
// module id = null
// module chunks = 